import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import CaseTypeOrganizationUnitButton from './CaseTypeOrganizationUnitButton';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-manager-organization-unit-detail-button',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const organizationUnitId = container.getAttribute('organizationUnitId');
		const isOnlyOneRoot = parseBoolean(container.getAttribute('isOnlyOneRoot'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CaseTypeOrganizationUnitButton
							workplaceId={workplaceId}
							organizationUnitId={organizationUnitId}
							isOnlyOneRoot={isOnlyOneRoot}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
